"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SignInTypeKetys = void 0;
var SignInTypeKetys = exports.SignInTypeKetys = ['ACTIVATION', 'SIGN_IN', 'WATCHLIST', 'TRIP_PLAN', 'PROPERTY_ALERT', 'MY_ALLHOMES'];
var SignInTypeValues = {
  ACTIVATION: {
    type: 'ACTIVATION',
    title: "We're ready for you",
    subtitle: 'Log in to your Allhomes account'
  },
  SIGN_IN: {
    type: 'SIGN_IN',
    title: 'Welcome back',
    subtitle: 'Log in to your Allhomes account'
  },
  WATCHLIST: {
    type: 'WATCHLIST',
    title: 'Log in to use Watchlist',
    subtitle: "Allhomes is better when you're logged in"
  },
  TRIP_PLAN: {
    type: 'TRIP_PLAN',
    title: 'Log in to use Inspection Planner',
    subtitle: "Allhomes is better when you're logged in"
  },
  PROPERTY_ALERT: {
    type: 'PROPERTY_ALERT',
    title: 'Log in to create that alert',
    subtitle: "The party starts when you're all logged in. \nCreate property alerts, stay synced across devices and more."
  },
  MY_ALLHOMES: {
    type: 'MY_ALLHOMES',
    title: 'Welcome back',
    subtitle: 'Log in to your Allhomes account'
  }
};
var SignInType = SignInTypeValues;
var _default = exports.default = SignInType;